import { httpClient } from '@/services/http/httpClient'

export type CreateCommentProps = {
  projectId: string
  title: string
  comment: string
  attachment?: File
  subCommentId?: string
}

export async function createComment({
  comment,
  projectId,
  title,
  attachment,
  subCommentId,
}: CreateCommentProps) {
  const payload = new FormData()
  payload.append('title', title)
  payload.append('comment', comment)
  payload.append('projectId', projectId)

  if (attachment) {
    payload.append('file', attachment)
  }

  if (subCommentId) {
    payload.append('subCommentId', subCommentId)
  }

  await httpClient.post(`/projects/project-comments/${projectId}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
